import { useState } from 'react';
import { useIsomorphicLayoutEffect } from 'ahooks';
export function useInnerVisible(outerVisible) {
    var _a = useState(outerVisible), innerVisible = _a[0], setInnerVisible = _a[1];
    useIsomorphicLayoutEffect(function () {
        setInnerVisible(outerVisible);
    }, [outerVisible]);
    return innerVisible;
}
